<template>
  <span v-if="card.visible">
    <v-card
      class="pa-4 d-flex flex-column align-center justify-center"
      min-width="230px"
      min-height="150px"
      outlined
      :ripple="false"
      style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);"
    >
      <v-icon size="40px" color="rgba(0, 0, 0, 0.7)">
        {{ card.icon }}
      </v-icon>
      <div class="cardText">
        {{ card.text }}
      </div>
      <base-button
        :translation-path="card.buttonTranslationPath || 'button.manage'"
        style="margin-right: 0"
        @click="card.action"
      ></base-button>
    </v-card>
  </span>
</template>

<script>
import BaseButton from '@/components/BaseButton';
export default {
  name: 'CockpitLinkCard',
  components: { BaseButton },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.cardText {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #9fa2b4;
  word-break: break-all;
  padding: 15px 0 12px;
}
</style>
